import { motion } from "framer-motion";
import React, { useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import theme from "../theme/theme1";

const MessageCard = ({ title, message, author, role, imageUrl }) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => setExpanded(!expanded);

  const truncatedMessage =
    message.length > 150 && !expanded ? `${message.slice(0, 150)}...` : message;

  return (
    <motion.div
      className="relative shadow-lg rounded-2xl p-6 w-full max-w-sm mx-4 mb-8 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      style={{
        backgroundColor: theme.MessageCards.backgroundColor,
        fontFamily: theme.fontFamily,
        boxShadow: theme.MessageCards.boxShadow,
      }}
      whileHover={{ boxShadow: theme.MessageCards.hoverBoxShadow }}
    >
      {/* Profile Image */}
      <div className="absolute -top-12 left-1/2 transform -translate-x-1/2">
        <motion.img
          src={imageUrl}
          alt={`${title} Image`}
          className="w-24 h-24 rounded-full border-4 border-white shadow-lg transition-transform transform hover:scale-110 duration-300"
          style={{
            boxShadow: theme.MessageCards.imageBoxShadow,
          }}
          whileHover={{ boxShadow: theme.MessageCards.hoverImageBoxShadow }}
        />
      </div>

      {/* Message Content */}
      <div className="mt-16 text-center">
        <h3
          className="text-2xl font-semibold transition-all duration-300"
          style={{ color: theme.MessageCards.titleColor }}
        >
          {title}
        </h3>
        <div className="w-16 h-1 bg-[#b5a262] mx-auto my-2"></div>

        {/* Message */}
        <div
          className={`mt-4 text-base leading-relaxed overflow-hidden transition-all duration-300 ${
            expanded ? "max-h-none" : "max-h-24"
          }`}
          style={{ color: theme.MessageCards.messageColor }}
        >
          {truncatedMessage}
        </div>

        {message.length > 150 && (
          <button
            onClick={handleToggle}
            className="mt-4 text-base font-semibold flex items-center justify-center transition-all duration-300 focus:outline-none"
            style={{ color: theme.MessageCards.buttonTextColor }}
          >
            {expanded ? "Show Less" : "Read More"}
            <FaArrowRight className="ml-2" />
          </button>
        )}

        <p
          className="mt-4 text-base font-medium"
          style={{ color: theme.MessageCards.authorColor }}
        >
          {author} ({role})
        </p>
      </div>
    </motion.div>
  );
};

const MessageCards = () => {
  const messages = [
    {
      title: "Chairman's Message",
      message:
        "Velammal Nexus is committed to nurturing an inclusive educational environment, fostering the development of critical thinking, innovation, and integrity among our students. We envision a generation that values not only academic excellence but also holistic development, shaping global citizens who are both skilled and compassionate. Together, we strive for a learning experience that will prepare our students to overcome future challenges and succeed in a rapidly evolving world.",
      author: "Mr. Rajesh Kumar",
      role: "Chairman",
      imageUrl:
        "https://velammalnexus.com/wp-content/uploads/2023/10/chaiman-img.jpg",
    },
    {
      title: "Principal's Message",
      message:
        "Velammal Nexus is committed to nurturing an inclusive educational environment, fostering the development of critical thinking, innovation, and integrity among our students. We envision a generation that values not only academic excellence but also holistic development, shaping global citizens who are both skilled and compassionate. Together, we strive for a learning experience that will prepare our students to overcome future challenges and succeed in a rapidly evolving world.",
      author: "Dr.Varadarajan",
      role: "Principal",
      imageUrl:
        "https://velammalnexus.com/wp-content/uploads/2023/10/correspondent-img.png",
    },
  ];

  return (
    <div
      className="py-12 px-4 bg-gradient-to-r from-[#b3a369] to-[#f8f4e8] font-sans relative overflow-hidden"
      style={{ fontFamily: theme.fontFamily }}
    >
      {/* Soft Lighting Effects */}
      <div className="absolute inset-0 bg-radial-gradient-light"></div>

      {/* Parallax Scrolling Background */}
      <div className="absolute inset-0 bg-parallax-light"></div>

      <h2
        className="text-4xl md:text-5xl font-bold text-center mb-12 relative z-10"
        style={{ color: theme.MessageCards.titleColor }}
      >
        <motion.span
          className="inline-block"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Messages from Our Leadership
        </motion.span>
      </h2>

      {/* Decorative Section Divider Line with Effects */}
      <div className="w-full h-1 bg-[#b5a262] mx-auto my-2 relative z-10">
        <motion.div
          className="w-full h-full bg-gradient-to-r from-transparent to-[#b5a262]"
          initial={{ width: "0%" }}
          animate={{ width: "100%" }}
          transition={{ duration: 1 }}
        ></motion.div>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center gap-8 relative z-10">
        {messages.map((messageData, index) => (
          <MessageCard key={index} {...messageData} />
        ))}
      </div>
    </div>
  );
};

export default MessageCards;
